import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import Box from "@mui/material/Box";
import _ from "lodash";
import { useEffect } from "react";
import { FormPasswordUIItem } from "../commons";
import { useState } from "react";
import FormHelperText from "@mui/material/FormHelperText";
import {
  registerTFA,
  generateQR,
} from "domain/apis/twoFactorAuthencatorService";

function TFADialog({ show, handleClose, data }) {
  const [formUI, setFormUI] = useState({});
  const [error, setError] = useState({});
  const [qr, setQR] = useState("");

  useEffect(() => {
    setError({});
  }, [show]);

  useEffect(() => {
    if (!data) {
      setFormUI({ tfa: false });
    } else {
      setFormUI(data);
    }

    if (data?.tfa === false) {
      generateQR().subscribe({
        next: ({ data }) => {
          setQR(data?.data ?? "");
        },
      });
    }
  }, [data, show]);

  const handleUpdateForm = (key, value) => {
    let obj = {};
    obj[key] = value;
    setFormUI({
      ...formUI,
      ...obj,
    });
  };

  const validateForm = () => {
    var result = true;
    var errorState = {};

    if (!formUI["code"] || formUI["code"] === "") {
      result = false;
      errorState.code = true;
    }

    setError(errorState);
    return result;
  };

  const onModify = () => {
    if (!validateForm()) {
      return;
    }

    registerTFA({
      code: formUI?.code,
      enabled: data?.tfa !== true,
    }).subscribe({
      next: () => {
        handleClose(true);
      },
      error: (err) => {
        alert(err.message);
      },
    });
  };

  return (
    <>
      <Modal
        show={show}
        onHide={() => handleClose()}
        centered
        style={{ zIndex: 10000 }}
      >
        <Modal.Header>
          <div
            style={{ display: "flex", justifyContent: "center", width: "100%" }}
          >
            <Modal.Title>Cài đặt TFA</Modal.Title>
          </div>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Box sx={{ display: "flex", flexWrap: "wrap" }}>
              {!data?.tfa && (
                <div>
                  <img
                    style={{ width: 196, height: 196 }}
                    src={qr}
                    className="rounded mr-2"
                    alt=""
                  />
                  <FormHelperText error id={`outlined-info`}>
                    <b>Mã cài đặt QR (vui lòng bảo mật)</b>
                  </FormHelperText>
                </div>
              )}
              <FormPasswordUIItem
                label={"Mã xác nhận"}
                code={"code"}
                error={_.get(error, "code")}
                errorMessage={"Vui lòng nhập!"}
                required
                initValue={_.get(data, "password")}
                handleUpdate={handleUpdateForm}
              />
            </Box>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleClose()}>
            Hủy
          </Button>
          <Button variant="primary" onClick={() => onModify()}>
            {data?.tfa === true ? "Huỷ TFA" : "Cài đặt TFA"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default TFADialog;
